module.exports = __webpack_public_path__ + "img/CECA_Mast.07cb34ef.png";